import React from 'react';
import TaskTabPlaceholder from '../TaskTabPlaceholder.jsx';

const MaterialsTab = () => <TaskTabPlaceholder label="Materiales" />;

export default MaterialsTab;